import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import { ArrowLeft, Briefcase, Star } from "lucide-react";

export default function DaftarTutor() {
  const [tutorList, setTutorList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchTutor() {
      const { data } = await supabase
        .from("tutor")
        .select("*")
        .order("nama_lengkap");
      setTutorList(data || []);
      setLoading(false);
    }
    fetchTutor();
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "600px",
        margin: "0 auto",
        fontFamily: "sans-serif",
        background: "#fafafa",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
        }}
      >
        <Link to="/" style={{ color: "#666" }}>
          <ArrowLeft size={24} />
        </Link>
        <h2 style={{ margin: 0 }}>Pengajar Kami</h2>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={{ display: "grid", gap: "20px" }}>
          {tutorList.map((tutor) => (
            <div
              key={tutor.id}
              style={{
                background: "white",
                borderRadius: "15px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              {/* Header Foto & Nama */}
              <div
                style={{
                  display: "flex",
                  padding: "20px",
                  gap: "20px",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <img
                  src={tutor.foto_url || "https://via.placeholder.com/150"}
                  alt={tutor.nama_lengkap}
                  style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #E3F2FD",
                  }}
                />
                <div>
                  <h3 style={{ margin: "0 0 5px 0", color: "#333" }}>
                    {tutor.nama_lengkap}
                  </h3>
                  <span
                    style={{
                      background: "#E3F2FD",
                      color: "#1565C0",
                      padding: "4px 10px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    {tutor.mapel}
                  </span>
                </div>
              </div>

              {/* Detail Info */}
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginBottom: "10px",
                    color: "#555",
                    fontSize: "14px",
                  }}
                >
                  <Briefcase size={16} color="#F57C00" />
                  <strong>Pengalaman:</strong> {tutor.pengalaman}
                </div>

                <div
                  style={{
                    background: "#FFF8E1",
                    padding: "15px",
                    borderRadius: "10px",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    color: "#5D4037",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      marginBottom: "5px",
                      fontWeight: "bold",
                    }}
                  >
                    <Star size={14} fill="#FBC02D" stroke="none" /> Fokus
                    Pembelajaran:
                  </div>
                  "{tutor.fokus}"
                </div>
              </div>
            </div>
          ))}
          {tutorList.length === 0 && (
            <p style={{ textAlign: "center", color: "#999" }}>
              Belum ada data tutor.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
